(() => {
  if (window.FoCookieConsent) return;
  const root = document.documentElement;
  const templates = {
    analytics: 'ZQOx-TM97Y3rLe',
    marketing: 'zixK7I8y1mhf1D',
    preferences: 'T4PQQdTkrEofhd'
  };
  let privacyReady = false;
  let pendingConsent;
  let revision = 0;
  let saveTimer;
  const services = () => window.UC_UI?.getServicesBaseInfo?.() || [];
  const isInitialized = () => Boolean(window.UC_UI?.isInitialized?.());
  const updateReady = () => {
    root.classList.toggle('fo-cookie-consent-ready', privacyReady && isInitialized());
  };
  const flush = () => {
    if (!privacyReady || !pendingConsent) return;
    const consent = pendingConsent;
    const currentRevision = revision;
    pendingConsent = undefined;
    window.Shopify.customerPrivacy.setTrackingConsent(consent, result => {
      if (currentRevision !== revision) return;
      if (result?.error) {
        root.dataset.foConsentSync = 'error';
        return;
      }
      root.dataset.foConsentSync = 'saved';
      for (const purpose of Object.keys(templates)) {
        root.setAttribute(`data-fo-consent-${purpose}`, String(consent[purpose]));
      }
    });
  };
  const record = consent => {
    revision += 1;
    pendingConsent = consent;
    root.dataset.foConsentSync = 'pending';
    flush();
  };
  const readChoice = () => {
    if (!isInitialized()) return;
    const list = services();
    if (!Object.values(templates).every(id => list.some(service => service.id === id))) return;
    record(Object.fromEntries(Object.entries(templates).map(([purpose, id]) => [purpose, list.find(service => service.id === id).consent?.status === true])));
  };
  const initialized = () => {
    updateReady();
    const list = services();
    const hasPreviousChoice = list.some(service => service.consent?.history?.some(entry => String(entry.type).toLowerCase() === 'explicit'));
    if (hasPreviousChoice) readChoice();
  };
  window.addEventListener('UC_UI_INITIALIZED', initialized);
  window.addEventListener('UC_UI_CMP_EVENT', event => {
    const action = event.detail?.type;
    if (!['ACCEPT_ALL', 'DENY_ALL', 'SAVE'].includes(action)) return;
    clearTimeout(saveTimer);
    if (action !== 'SAVE') {
      record(Object.fromEntries(Object.keys(templates).map(purpose => [purpose, action === 'ACCEPT_ALL'])));
    } else {
      saveTimer = setTimeout(readChoice, 100);
      setTimeout(readChoice, 500);
    }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-fo-cookie-settings]');
    if (!link || !isInitialized()) return;
    event.preventDefault();
    window.UC_UI.showSecondLayer();
  });
  window.FoCookieConsent = { open: () => { if (isInitialized()) window.UC_UI.showSecondLayer(); } };
  const loadPrivacy = attempt => {
    if (!window.Shopify?.loadFeatures) {
      if (attempt < 40) setTimeout(() => loadPrivacy(attempt + 1), 250);
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      privacyReady = !error && Boolean(window.Shopify.customerPrivacy?.setTrackingConsent);
      updateReady();
      if (privacyReady) flush();
    });
  };
  loadPrivacy(0);
  if (isInitialized()) initialized();
})();
